import { render } from "./TableForm.vue?vue&type=template&id=6eb9bee6&ts=true"
import script from "./TableForm.vue?vue&type=script&lang=ts"
export * from "./TableForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/TableForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6eb9bee6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6eb9bee6', __exports__)) {
    api.reload('6eb9bee6', __exports__)
  }
  
  module.hot.accept("./TableForm.vue?vue&type=template&id=6eb9bee6&ts=true", () => {
    api.rerender('6eb9bee6', render)
  })

}


export default __exports__